import React from "react";
import "./App.css";

import { msalConfig } from "./config";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { ErrorBoundary } from "./ErrorBoundary";
import { Router } from "./Router";

const App: React.FC = () => {
  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <div className="App">
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <Router />
        </MsalProvider>
      </ErrorBoundary>
    </div>
  );
};

export default App;
